import * as yup from 'yup';

const translationRecord = yup.object().optional();

export const priorityLevelSchema = yup.object().shape({
  name: yup.string().required('common.fieldRequired'),
  id_code: yup.string().required('common.fieldRequired'),
  color_code: yup.string().required('common.fieldRequired'),
  name_translations: translationRecord,
  id_code_translations: translationRecord
});

export const priorityLevelEditSchema = priorityLevelSchema;
